import 'core-js/modules/es.object.assign.js';
import { jsx } from 'react/jsx-runtime';
import { Stack, Text } from '@hub-la/design-system';
import { useTranslation } from 'react-i18next';
import { EventLiveContainer } from './event-live-tag.styled.js';

const EventLiveTag = () => {
  const {
    t
  } = useTranslation();
  return jsx(Stack, Object.assign({
    pt: 4
  }, {
    children: jsx(EventLiveContainer, {
      children: jsx(Text, Object.assign({
        variant: "caption",
        color: "onPrimary"
      }, {
        children: jsx("b", {
          children: t('postDetail.meeting.liveNow')
        })
      }))
    })
  }));
};

export { EventLiveTag };
